import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { TransportMethod } from './transport-method.interface';
import { TransportMethodService } from './transport-method.service';

const service = new TransportMethodService();

export interface TransportMethodState {
   transportMethods: Array<TransportMethod>;
}

const TransportMethodStore: Module<TransportMethodState, StoreState> = {
   namespaced: true,
   state: {
      transportMethods: [],
   },
   getters: {
      transportMethods: (state) => state.transportMethods,
   },
   mutations: {
      SET_TRANSPORT_METHODS(state, transportMethods: Array<TransportMethod>) {
         state.transportMethods = transportMethods;
      },
   },
   actions: {
      async getTransportMethods(context, query: LocationQuery) {
         const response = await service.getTransportMethods({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_TRANSPORT_METHODS', response.data);
         return response;
      },
   },
};

export default TransportMethodStore;
